import request from '@/utils/request'
import qs from 'qs'
//获取报销自定义字段
export function getSelfAPI(data) {
  return request({
    url: 'https://api.weijub.com/crm/ApplyExpense/get_custom_filed',
    method: 'POST',
    data: qs.stringify(data)
  })
}
//获取报销信息
export function getApplyExpenseAPI(data) {
  return request({
    url: 'https://api.weijub.com/crm/ApplyExpense/get_custom_filed',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 获取当前企业使用的版本
export function getAccountPriveCount(params) {
  return request({
    url: '/crm/Mymine/getAccountPriveCount',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 检测是否有重复的电话
export function checkPhone(params) {
  return request({
    url: '/crm/Mymine/checkPhone',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function getSourceList(params) {
  return request({
    url: '/crm/Mymine/getSourceList',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function recordList(params) {
  return request({
    url: '/crm/Record/recordList',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function addRecord(params) {
  return request({
    url: '/crm/Record/addRecord',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function editRecord(params) {
  return request({
    url: '/crm/Record/editRecord',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function addComment(params) {
  return request({
    url: '/crm/Record/addObserverContent',
    method: 'POST',
    data: qs.stringify(params)
  })
}


export function contactsList(params) {
  return request({
    url: '/crm/Contacts/contactsList',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function readContacts(params) {
  return request({
    url: '/crm/Contacts/readContacts',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function editContacts(params) {
  return request({
    url: '/crm/Contacts/editContacts',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function addContacts(params) {
  return request({
    url: '/crm/Contacts/addContacts',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function delContacts(params) {
  return request({
    url: '/crm/Contacts/delContacts',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function actionLogList(params) {
  return request({
    url: '/crm/ActionLog/actionLogList',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function transferUser(params) {
  return request({
    url: '/crm/Mymine/transferUser',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function transferUsers(params) {
  return request({
    url: '/crm/Mymine/transferUsers',
    method: 'POST',
    data: qs.stringify(params)
  })
}


export function getCooperationUser(params) {
  return request({
    url: '/crm/Mymine/getCooperationUser',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function putIntoSea(params) {
  return request({
    url: '/crm/Mymine/putIntoSea',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function putIntoSeas(params) {
  return request({
    url: '/crm/Mymine/putIntoSeas',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function getReceivablesPlanByContract(params) {
  return request({
    url: '/crm/Contract/getReceivablesPlanByContract',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function getExamineUserPc(params) {
  return request({
    url: '/crm/Mymine/getExamineUserPc',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function getChatInfo(params) {
  return request({
    url: '/crm/Leads/getChatInfo',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function updateChatInfos(params) {
  return request({
    url: '/crm/Leads/getChatInfos',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 根据userid获取下属的userid和姓名
export function getUnderUser(params) {
  return request({
    url: '/crm/Customer/getUnderUser',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 获取报销事项列表
export function getApplyItemList(params) {
  return request({
    url: '/crm/Mymine/getApplyItemList',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 报销详情页面的审批流程
export function getExamineUserPcApply(params) {
  return request({
    url: '/crm/Mymine/getExamineUserPcApply',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 公告列表
export function getLookNotice(params) {
  return request({
    url: '/crm/Mymine/lookNotice',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 企业名片--列表
export function getUserCard(params) {
  return request({
    url: '/crm/UserCard/list      ',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 文案库列表
export function getCardContentList(params) {
  return request({
    url: '/crm/UserCardContent/list',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 名片添加
export function userCardAdd(params) {
  return request({
    url: '/crm/UserCard/add',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 生成名片链接
export function getShortLink(params) {
  return request({
    url: '/crm/UserCard/getShortLink',
    method: 'POST',
    data: qs.stringify(params)
  })
}



